import React from 'react';
import Popper, { HintPlacement } from '@zvuk-b2b/react-uikit/ui/Popper';
import Input, { InputSize, InputType } from '@zvuk-b2b/react-uikit/ui/Input';
import { TEXTS } from '../../../texts';

interface VideoRepeatControlProps {
  repeatCount: number;
  isValid: boolean;
  isBlockedDurationEdit: boolean;
  onBlur: (event: React.FocusEvent<HTMLInputElement, Element>) => void;
  onChange: (durationString: string) => void;
}

const VideoRepeatControl: React.FC<VideoRepeatControlProps> = ({
  repeatCount,
  isValid,
  isBlockedDurationEdit,
  onBlur,
  onChange,
}) => (
  <Popper
    placement={HintPlacement.PLACEMENT_TOP_START}
    offset={[10, 10]}
    isShow={isBlockedDurationEdit}
    triggerNode={
      <Input
        value={String(repeatCount)}
        size={InputSize.MEDIUM}
        type={InputType.NUMBER}
        maxLength={3}
        min={1}
        isDisabled={isBlockedDurationEdit}
        autoComplete="off"
        elementId="video_mediafiles_count"
        placeholder="1"
        forceError={!isValid}
        onChange={onChange}
        onBlur={onBlur}
      />
    }>
    {TEXTS.BLOCK_EDIT_WARNING}
  </Popper>
);

export default VideoRepeatControl;
